module.exports = __webpack_public_path__ + "static/media/Mihir_Gokhale.72eda118.png";